import React from "react";
import SessionHistory from "../components/profile/SessionHistory";

const ActivityView = () => {
  return (
    <div className="mx-auto max-w-5xl">
      <SessionHistory title="Activity" />
    </div>
  );
};

export default ActivityView;
